// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1pPTm","header":"PatientQuestionnaire_header__1_0SR","info":"PatientQuestionnaire_info__1FnDx"};